import urls from "./urls";
import axios from 'axios';
import Token from "../util/Token";
import { preparePayloadForApi, processApiResponse } from "../util/apiTimezoneHandler";

function queryString(u, query){
    if(query.hasOwnProperty('queryParameters')){
        const { queryParameters } = query;
        const url = new URL(u);
        for(let [k, v] of Object.entries(queryParameters)){
            url.searchParams.set(k, v);
        }
        u = url;
    }
    return u;
}

let url = null;
let authHeader = {
    Authorization: `Bearer ${Token.get()}`
}

const services = {
    addToFavourites: async (data) => {
        const payload = preparePayloadForApi(data);
        return await axios.post(urls.ADD_FAVOURITES, payload);
    },
    removeFromFavourites: async (data) => {
        const payload = preparePayloadForApi(data);
        return await axios.post(urls.REMOVE_FAVOURITES, payload);
    },
    getLocationDetail: async (data) => {
        url = queryString(urls.GET_LOCATION_DETAILS, data);
        const response = await axios.get(url);
        return processApiResponse(response);
    },
    reportIssue: async (data) => {
        const payload = preparePayloadForApi(data);
        return await axios.post(urls.REPORT_ISSUE, payload)
    },
    getReportedIssues: async (data) => {
        url = queryString(urls.GET_REPORTED_ISSUE, data)
        const response = await axios.get(url);
        return processApiResponse(response);
    },
    reaction: async (data) => {
        const payload = preparePayloadForApi(data);
        return await axios.post(urls.REACTION, payload);
    },
    getReactions: async (data) => {
        url = queryString(urls.GET_REACTIONS, data);
        const response = await axios.get(url);
        return processApiResponse(response);
    },
    uploadImage: async (data) => {
        const uploadRes = await axios.post(urls.UPLOAD_IMAGE, { image: data.image });
        return await axios.post(urls.ADD_IMAGE, { id: data.id, imagePath: uploadRes.data.data })
    },
    removeImage: async (data) => {
        const payload = preparePayloadForApi(data);
        return await axios.post(urls.REMOVE_IMAGE, payload);
    },
    getUser: async (data) => {
        url = queryString(urls.GET_USER, data);
        const response = await axios.get(url, { headers: authHeader });
        return processApiResponse(response);
    },
    createTrip: async (data) => {
        const payload = preparePayloadForApi(data);
        return await axios.post(urls.CREATE_TRIP, payload)
    },
    updateTrip: async (data) => {
        const payload = preparePayloadForApi(data);
        return await axios.post(urls.UPDATE_TRIP, payload);
    },
    getTrip: async (data) => {
        url = queryString(urls.GET_TRIP, data);
        const response = await axios.get(url, { headers: authHeader });
        return processApiResponse(response);
    },
    deleteTrip: async (data) => {
        url = queryString(urls.DELETE_TRIP, data);
        return await axios.delete(url, { headers: authHeader });
    }
}

async function HttpService(methodName, data){
    try{
        const response = await services[methodName](data);
        if (!response.status) {
            throw new Error(response.statusText)
        }

        return {
            type: 'ok',
            status: response.status,
            data: response.data.data
        }
    }catch(err){
        return {
            type: 'error',
            status: false,
            message: err.message
        }
    }
}

export default HttpService